import { useEffect, useState } from "react";
import useTranslator from "../../hooks/useTranslator";
import styles from "./authenticateYourId/authenticateYourId.module.css";

const KycVerificationPopup = ({ showPopup, onContinue, isGuarantor }) => {
  const { _t } = useTranslator();
  const [isContinuing, setIsContinuing] = useState(false);

  useEffect(() => {
    if (showPopup) setIsContinuing(false);
  }, [showPopup]);

  const handleContinue = async () => {
    if (isContinuing) return;
    setIsContinuing(true);
    try {
      await onContinue?.();
    } finally {
      setIsContinuing(false);
    }
  };

  return (
    <>
      {showPopup && (
        <div
          className={`${styles.overlay} popup-overlay fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 wrapper-modal modal-fixed-screen ${isGuarantor ? "guarantorBg" : ""}`}
          style={{ zIndex: 100 }}
        >
          <div
            className={`popup-content2 popup-content bg-white ${styles.kycSubmittedPopup} ${styles.authModalSurface}`}
          >
            <div className={styles.kycSubmittedIconWrapper}>
              <div className={styles.kycSubmittedIconCircle}>
                <img
                  src="/images/document.svg"
                  alt="Document Icon"
                  className={styles.kycSubmittedIcon}
                />
              </div>
            </div>

            <div className={`text-center ${styles.kycSubmittedHeader}`}>
              <h4>{_t("kycAnimationScreenTitle")}</h4>
              <p>{_t("kycAnimationScreenDescription")}</p>
              <p>{_t("kycAnimationScreenSubDescription")}</p>
            </div>

            <div className={styles.kycStatusIndicator}>
              <span
                className={`${styles.kycStatusDot} ${styles.kycStatusDotOne}`}
              ></span>
              <span
                className={`${styles.kycStatusDot} ${styles.kycStatusDotTwo}`}
              ></span>
              <span
                className={`${styles.kycStatusDot} ${styles.kycStatusDotThree}`}
              ></span>
              <span className={styles.kycStatusLabel}>{_t("inReview")}</span>
            </div>

            <button
              type="button"
              className={`btnNext ${styles.kycContinueButton}`}
              onClick={handleContinue}
              disabled={isContinuing}
            >
              {_t("continue", "Continue")}
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default KycVerificationPopup;
